'use client';

import { c as _c } from "react/compiler-runtime";
import { unwrapFromResult } from '@shared/utils/helpers/resultWrapper';
import toast from '@shared/utils/helpers/toast';
import useUser from '@shared/utils/hooks/useUser';
import { useInfiniteQuery } from '@tanstack/react-query';
import { Loader2 } from 'lucide-react';
import { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { client, type RouterOutputs } from '../../utils/trpc';
import { useAuthModals } from '../../widgets/WidgetsContext';
import InlineProfileCard from '../profile/InlineProfileCard';
type Props = {
  slug: string;
  space: RouterOutputs['spaces']['get'];
};
const SpaceMembersList = props => {
  const $ = _c(37);
  const {
    currentUser
  } = useUser();
  const {
    openAuthContinueModal
  } = useAuthModals();
  const {
    ref: loadingSectionRef,
    inView
  } = useInView();
  let t0;
  let t1;
  if ($[0] !== props.slug) {
    t0 = ["SpaceMembersList", props.slug];
    t1 = t2 => {
      const {
        pageParam
      } = t2;
      return unwrapFromResult(client.spaces.memberlist.query({
        slug: props.slug,
        cursor: pageParam
      }));
    };
    $[0] = props.slug;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t0 || $[4] !== t1) {
    t2 = {
      queryKey: t0,
      queryFn: t1,
      initialPageParam: undefined as number | undefined,
      getNextPageParam: _temp,
      select: _temp3
    };
    $[3] = t0;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const {
    data: userList,
    isLoading: loading,
    error,
    hasNextPage,
    fetchNextPage
  } = useInfiniteQuery(t2);
  let t3;
  if ($[6] !== fetchNextPage || $[7] !== inView || $[8] !== loading) {
    t3 = () => {
      if (inView && !loading) {
        fetchNextPage();
      }
    };
    $[6] = fetchNextPage;
    $[7] = inView;
    $[8] = loading;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== inView) {
    t4 = [inView];
    $[10] = inView;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  useEffect(t3, t4);
  let t5;
  let t6;
  if ($[12] !== error) {
    t5 = () => {
      if (error) {
        toast(error?.message || String(error), "", "error");
      }
    };
    t6 = [error];
    $[12] = error;
    $[13] = t5;
    $[14] = t6;
  } else {
    t5 = $[13];
    t6 = $[14];
  }
  useEffect(t5, t6);
  let t7;
  if ($[15] !== currentUser || $[16] !== error || $[17] !== loading || $[18] !== openAuthContinueModal || $[19] !== props.space || $[20] !== userList) {
    t7 = !loading && !error && userList?.map(aUser => <InlineProfileCard key={aUser.id} showAuthModal={openAuthContinueModal} loggedIn={currentUser.isAuthenticated} title="Space Members" isSpace={true} isInvited={aUser.isInvited} invitedByName={aUser.invitedByName} invitedEmail={aUser.invitedEmail} user={aUser} space={props.space} />);
    $[15] = currentUser;
    $[16] = error;
    $[17] = loading;
    $[18] = openAuthContinueModal;
    $[19] = props.space;
    $[20] = userList;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== t7) {
    t8 = <div className="space-y-1">{t7}</div>;
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] !== loading) {
    t9 = loading && <p className="text-center text-textSecondary/70">Loading results...</p>;
    $[24] = loading;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== error) {
    t10 = error && <p className="text-center text-destructive">An error occurred. Please try again later.</p>;
    $[26] = error;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  const t11 = `flex w-full justify-center ${hasNextPage ? "block" : "hidden"}`;
  let t12;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Loader2 className="animate-spin" height={50} width={50} />;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== loadingSectionRef || $[30] !== t11) {
    t13 = <div ref={loadingSectionRef} className={t11}>{t12}</div>;
    $[29] = loadingSectionRef;
    $[30] = t11;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] !== t10 || $[33] !== t13 || $[34] !== t8 || $[35] !== t9) {
    t14 = <>{t8}{t9}{t10}{t13}</>;
    $[32] = t10;
    $[33] = t13;
    $[34] = t8;
    $[35] = t9;
    $[36] = t14;
  } else {
    t14 = $[36];
  }
  return t14;
};
export default SpaceMembersList;
function _temp(lastPage) {
  if (lastPage.users.length < 10) {
    return;
  }
  return lastPage.users[lastPage.users.length - 1]?.spaceMemberId;
}
function _temp2(page) {
  return page.users;
}
function _temp3(data) {
  return data.pages.flatMap(_temp2);
}